module.exports = __webpack_public_path__ + "static/img/ng.992459a3.svg";